import styles from "../../style.module.scss";
import useStore from "../../store/store";
import formatDate from "../../utils/format-date";
import formatHours from "../../utils/format-hours";
import {useState} from "react";
import {host} from "../../const/const";

const Submit = ({
    countDays,
    rate,
    rateSum,
    sale,
    surchargeSum,
    version = 1,
    avgPerDay = 0,
    rentGross = 0,
    loyaltyDiscount = 0,
    promoDiscount = 0,
    superSaleDiscount = 0,
    daySaleDiscount = 0,
    periodSaleDiscount = 0,
    periodSalePercent = 0,
    bonusSum = 0,
    insuranceSum = 0,
    servicesSum = 0,
    deliverySum = 0,
    returnSum = 0,
    deliveryLocationId = undefined,
    returnLocationId = undefined,
    pricesReady = true,
}) => {
    const userName = useStore((state) => state.userName)
    const setUserNameError = useStore((state) => state.setUserNameError)
    const userTel = useStore((state) => state.userTel)
    const setUserTelError = useStore((state) => state.setUserTelError)
    const userTg = useStore((state) => state.userTg)
    const userComment = useStore((state) => state.userComment)
    const carId = useStore((state) => state.carId)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const currentInsurance = useStore((state) => state.currentInsurance)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const carReturnLocation = useStore((state) => state.carReturnLocation)
    const carServices = useStore((state) => state.carServices)
    const promoCode = useStore((state) => state.promoCode)
    const isApplyPromoCode = useStore((state) => state.isApplyPromoCode)
    const promoCodeSale = useStore((state) => state.promoCodeSale)
    const bonusPay = useStore((state) => state.bonusPay)
    const payMethod = useStore((state) => state.payMethod)
    const surcharge = useStore((state) => state.surcharge)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const lang = useStore((state) => state.lang)
    const isV2 = Number(version) === 2;

    const t = {
        selectRentalPeriod: lang === 'en' ? 'Select rental period' : 'Выберите период аренды',
        fillPhoneField: lang === 'en' ? 'Fill in the Phone field' : 'Заполните поле Телефон',
        fillNameField: lang === 'en' ? 'Fill in the Name field' : 'Заполните поле Фио',
        refreshPage: lang === 'en' ? 'Refresh the page and try again' : 'Обновите страницу и поробуйте снова',
        pricesLoading: lang === 'en' ? 'Wait for the rental price to load' : 'Дождитесь загрузки стоимости аренды',
        sendingData: lang === 'en' ? 'Sending data...' : 'Отправка данных...',
        submitRequest: lang === 'en' ? 'Submit a rental request' : 'Оставить заявку на аренду'
    };

    const focusElement = (id) => {
        const inputElement = document.getElementById(id);

        if (inputElement) {
            inputElement.focus();
            inputElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }
    const disabled = () => {
        let status = true;
        let message = '';
        if (carId && carId > 0 && !!rate && !!rate.id) {
            if (!!userName && !!userName.length) {
                if (!!userTel && userTel.replaceAll(' ', '').length >= 12) {
                    if (!!startDate && !!startHours && !!finishDate && !!finishHours && !!countDays) {
                        if (isV2 && (!pricesReady || !(rateSum > 0))) {
                            message = t.pricesLoading;
                        } else {
                            status = false;
                        }
                    } else {
                        focusElement('userDateStart');
                        message = t.selectRentalPeriod;
                    }
                } else {
                    focusElement('userTel')
                    setUserTelError(t.fillPhoneField)
                    message = t.fillPhoneField;
                }
            } else {
                focusElement('userName')
                setUserNameError(t.fillNameField);
                message = t.fillNameField;
            }
        } else {
            message = t.refreshPage;
        }

        return [status, message];
    }
    const handleSubmit = async () => {
        setLoading(true)
        if (disabled()[0]) {
            setError(disabled()[1])
            setLoading(false)
        } else {
            const deliveryLocation = deliveryLocationId !== undefined
                ? deliveryLocationId
                : carDeliveryLocation;
            const returnLocation = returnLocationId !== undefined
                ? returnLocationId
                : carReturnLocation;

            const data = {
                action: 'send_lead',
                fio: userName,
                tel: userTel,
                tg: userTg.startsWith('@') ? userTg : '@' + userTg,
                comment: userComment,
                car: carId,
                start: `${formatDate(startDate)} ${formatHours(startHours)}`,
                finish: `${formatDate(finishDate)} ${formatHours(finishHours)}`,
                days: countDays,
                rateSum: rateSum,
                rate: rate.id,
                sale: sale[0],
                saleType: sale[1],
                insurance: currentInsurance,
                deliveryLocation,
                returnLocation,
                service: carServices?.map((item) => item.serviceId) || null,
                promoCode: isApplyPromoCode && !!promoCodeSale ? promoCode : null,
                bonusPay: bonusPay,
                payMethod: payMethod,
                surcharge: surcharge,
                surchargeSum: surchargeSum,
            };

            if (isV2) {
                data.ver = 2;
                data.avgPerDay = avgPerDay;
                data.rentGross = rentGross;
                data.loyaltyDiscount = loyaltyDiscount;
                data.promoDiscount = promoDiscount;
                data.superSaleDiscount = superSaleDiscount;
                data.daySaleDiscount = daySaleDiscount;
                data.periodSaleDiscount = periodSaleDiscount;
                data.periodSalePercent = periodSalePercent;
                data.bonusSum = bonusSum;
                data.insuranceSum = insuranceSum;
                data.servicesSum = servicesSum;
                data.deliverySum = deliverySum;
                data.returnSum = returnSum;
                data.total = surchargeSum;
            }

            try {
                const response = await fetch(host, {
                    method: "POST",
                    body: new URLSearchParams(data),
                });
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }
                const json = await response.json();
                window.location.href = '/thank/?p=' + json?.target_name;
            } catch (error) {
                console.error(error.message);
            } finally {
                setLoading(false)
            }
        }
    }
    if (loading) {
        return (<div className={styles.loading}>
            {t.sendingData}
        </div>)
    }
    return (
        <>
            <button type='button' className={styles.button} onClick={() => handleSubmit()}>
                {t.submitRequest}
            </button>
            {
                !!error && (<div className={styles.error}>{error}</div>)
            }
        </>
    );
};

export default Submit;
